import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { exportView, NavUtils } from "../../navigation";
import ViewTabs from "../../common/components/tabs/view-tabs/ViewTabs";
import { ViewBanner, ViewTabPanel } from "../../common/components";
import style from "./LicenceManagement.module.css";
import UserView from "./components/user-view/UserView";
import UserList from "./components/user-list/UserList";
import UserSearch from "./components/user-search/UserSearch";
import DistributionList from "./components/distribution-list/DistributionList";
import { translate } from "../../common/providers";

const LicenceManagement = () => {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const companyStore = useSelector(({ context }) => context.company);
	const navigate = useNavigate();
	const [selectedTab, setSelectedTab] = React.useState(0);

	useEffect(() => {
		if (companyStore.id !== 2 || !companyStore.roles.find((item) => item === "ADMIN")) {
			// add redirection to home if the company not veolia and the user don t have admin role
			navigate(NavUtils.goToHome());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const isVeolia = companyStore.id === 2; // Veolia ID check

	const tabs = [
		{ label: translate("common:licence-management.tab.title.members-management") },
		...(isVeolia ? [{ label: translate("admin.tab.title.distribution-list") }] : []),
	];

	return (
		<>
			<ViewBanner titles={[{ title: translate("navigation:home.admin") }]} />
			<Grid className={style.container}>
				<ViewTabs
					noPadding
					noShadow
					className={style.tabNavigation}
					selectedTab={selectedTab}
					tabs={tabs}
					onChange={(_, val) => setSelectedTab(val)}
				/>

				<ViewTabPanel noPadding index={0} value={selectedTab}>
					<Grid container className={style.viewTabPanelContainer}>
						<Grid item md={6} p={1}>
							<UserSearch />
							<Grid item md={12}>
								<UserList />
							</Grid>
						</Grid>
						<Grid item className={style.sectionPreview} md={6} p={1}>
							{licenceManagementStore?.selectedUser && (
								<UserView user={licenceManagementStore?.selectedUser} />
							)}
						</Grid>
					</Grid>
				</ViewTabPanel>

				{isVeolia && (
					<ViewTabPanel noPadding className={style.tabPanelFullHeight} index={1} value={selectedTab}>
						<DistributionList />
					</ViewTabPanel>
				)}
			</Grid>
		</>
	);
};

export default exportView({
	path: "/licence-management",
	localesPath: "/license-management/locales",
	component: LicenceManagement,
});
